import React from 'react';
import PropTypes from 'prop-types';

const PriorityNeedSection = ({
  priorityUnmetNeed,
  unmetNeedsDisplayNames,
  onPriorityNeedChange,
  selectedSystemName,
  systemPercentage,
}) => (
  <div className="moved-priority-section mt-6 mb-6">
    <div className="priority-selector-section">
      <h2 className="text-xl font-semibold mb-3">Priority Unmet Need</h2>
      <div className="priority-selector">
        <select
          value={priorityUnmetNeed}
          onChange={onPriorityNeedChange}
          className="priority-select block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        >
          {unmetNeedsDisplayNames.map((need) => (
            <option key={need} value={need}>
              {need}
            </option>
          ))}
        </select>
      </div>
    </div>

    <div className="priority-context mt-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded-md">
      <p className="selected-percentage">
        Approximately <strong>{systemPercentage}%</strong> of patients at <strong>{selectedSystemName}</strong> have{' '}
        <strong>{priorityUnmetNeed}</strong>
      </p>
    </div>
  </div>
);

PriorityNeedSection.propTypes = {
  priorityUnmetNeed: PropTypes.string.isRequired,
  unmetNeedsDisplayNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  onPriorityNeedChange: PropTypes.func.isRequired,
  selectedSystemName: PropTypes.string.isRequired,
  systemPercentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default PriorityNeedSection;
